import { IResourceComponentsProps, useNotification } from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
} from "@pankod/refine-antd";
import { IUsers } from "interfaces";

export const UsersList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, sorter } = useTable<IUsers>({
    initialSorter: [
      {
        field: "UserId",
        order: "asc",
      },
    ],
  });
  const notification = useNotification();

  return (
    <List>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("name", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="email"
          key="email"
          title="Email"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("email", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="role"
          key="role"
          title="Permissões"
          render={(value) => <TextField value={Array.isArray(value) ? value.join(", ") : value} />}
          defaultSortOrder={getDefaultSortOrder("role", sorter)}
          sorter
        />
       
        <Table.Column<IUsers>
          title="Ações"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <ShowButton hideText size="small" recordItemId={record.id} />
              <DeleteButton 
                hideText 
                size="small" 
                recordItemId={record.id}
                onSuccess={(data) => {
                  const message = (data as any)?.data?.message || "Usuário deletado com sucesso.";
                  notification.open?.({
                    message,
                    type: "success",
                  });
                }}
                onError={(error) => {
                  const message = (error as any)?.response?.data?.message || (error as any)?.message || "Erro ao deletar usuário.";
                  notification.open?.({
                    message,
                    type: "error",
                  });
                }}
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
